var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "url(#paint0_linear_462_17015)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_462_17015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9512,
    cy: 14.3897,
    r: 9.56348,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_462_17015)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.4419,
    cy: 13.3701,
    r: 9.56348,
    fill: "url(#paint1_linear_462_17015)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3027 6.17092L13.8555 5.2765L13.4083 6.17092L11.2779 10.4316L7.04345 10.9609L6.09705 11.0792L6.7327 11.7903L9.66959 15.0756L8.86258 19.8105L8.69685 20.7829L9.57908 20.3417L13.8555 18.2035L18.1319 20.3417L19.0125 20.7821L18.8485 19.8112L18.0485 15.0756L20.9786 11.7898L21.6125 11.079L20.6675 10.9609L16.433 10.4316L14.3027 6.17092Z",
    fill: "url(#paint2_linear_462_17015)",
    stroke: "#F4CC64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_462_17015",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B23F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_462_17015",
    x1: 13.4419,
    y1: 3.80664,
    x2: 13.4419,
    y2: 22.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC91D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_462_17015",
    x1: 13.8555,
    y1: 6.39453,
    x2: 13.8555,
    y2: 19.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "#FDDF80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStartIcon);
export default __webpack_public_path__ + "static/media/gold-start-icon.df6aa1d01fbb937d69437ed3c492811e.svg";
export { ForwardRef as ReactComponent };